import { HttpParams } from '@angular/common/http';
import { RedirectFunction } from '@angular/router';

export const redirectWhileKeepingQueryParams =
	(redirectToUrl: string): RedirectFunction =>
	({ queryParams }) =>
		Object.keys(queryParams).length ? `${redirectToUrl}?${new HttpParams({ fromObject: queryParams }).toString()}` : redirectToUrl;
